<template>
  <div class="tag-in-order">
    <slot></slot>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scoped>
.tag-in-order {
  display: inline-block;
  background: #ebf8ff;
  border-radius: 2px;
  font-size: 10px;
  font-weight: 400;
  color: #1e8dff;
  line-height: 10px;
  padding: 2px;
}
</style>